// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import OEInstrumentLookupTemplate from '@front/templates/OEInstrumentLookupTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class OEInstrumentLookup extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'OEInstrumentLookup';
    }
    oninit() {
        super.oninit();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    setFocus() {
        const enabled = this.get('enabled');
        if (!enabled) {
            return;
        }
        super.setFocus();
        if (!isNullOrUndefined(this.Controls.TerceraInstrumentLookup)) {
            this.Controls.TerceraInstrumentLookup.setFocus();
        }
    }
    localize() {
        void this.set('label', Resources.getResource('panel.newOrderEntry.instrumentLabel'));
    }
}
ContainerControl.extendWith(OEInstrumentLookup, {
    template: OEInstrumentLookupTemplate,
    data: function () {
        return {
            label: '',
            account: null,
            instrument: null
        };
    }
});
